function getJobName(jobData) {
  const suffix = jobData.multiDaySuffix || jobData.multipleDays || "";
  return `${jobData.jobNumber}-${jobData.client}${
    suffix ? `-${suffix}` : ""
  }${jobData.jobTypeShort}`;
}

export default getJobName;
